import { Module } from "../../types/TenantInterfaces";
import ReadableFilter from "../CRM/ReadableFilter";
import FiltersButton from "./FiltersButton";

interface Props {
  title?: string;
  currentModule: Module | undefined | null;
  query: any;
  setQuery: any;
  onApply?: (newQuery: any) => void;
  onClear?: () => void;
  checkForFields?: boolean;
  fallbackMessage?: string;
  smallText?: string;
  moduleAPIName?: string;
  showVariables?: boolean;
  disabled?: boolean;
}

const FilterInput = ({
  title,
  currentModule,
  query,
  setQuery,
  onApply,
  onClear,
  checkForFields,
  fallbackMessage,
  smallText,
  moduleAPIName,
  showVariables,
  disabled,
}: Props) => {
  return (
    <>
      {title && <h3>{title}</h3>}
      <FiltersButton
        currentModule={currentModule}
        query={query}
        setQuery={setQuery}
        onApply={onApply}
        onClear={onClear}
        checkForFields={checkForFields}
        showVariables={showVariables}
        disabled={disabled}
        customComponent={({ onClick }) => (
          <ReadableFilter
            query={query}
            moduleAPIName={moduleAPIName}
            onClick={onClick}
            fallbackMessage={fallbackMessage}
            maxWidth="100%"
            disabled={disabled}
          />
        )}
      />
      {smallText && <div className="small mt-2 ml-1">{smallText}</div>}
    </>
  );
};

export default FilterInput;
